import { AutocompleteFormlyComponent } from './autocomplete-formly/autocomplete-formly.component';
import { FileNameInputComponent } from './file-name-input/file-name-input.component';
import { InputNameComponent } from './input-text/input-name.component';
import { TimezoneRegionsFormlyWrapperComponent } from '@sphere/platform';
import { FormlyAutocompleteComponent } from './autocomplete/formly-autocomplete.component';
import { DateFormatSelectorComponent } from './date-time-format-selector/date-format-selector.component';
import { DateSelectorComponent } from './date/date-selector.component';
import { FormlyFormArrayComponent } from './formly-form-array/formly-form-array.component';
import { FormlyFormGroupComponent } from './formly-form-group/formly-form-group.component';
import { SftpConfigComponent } from './sftp-config/sftp-config.component';
import { TimeFormatSelectorComponent } from './date-time-format-selector/time-format-selector.component';
import { TimeSelectorComponent } from './time/time-selector.component';
import { UserSelectorComponent } from './user-selector/user-selector.component';
import { ConfigOption } from '@ngx-formly/core';

export const formlyTypes: NonNullable<ConfigOption['types']> = [
    {
        name: 'ondate',
        component: DateSelectorComponent
    },
    {
        name: 'date',
        component: DateSelectorComponent
    },
    {
        name: 'input-name',
        component: InputNameComponent
    },
    {
        name: 'autocomplete',
        component: AutocompleteFormlyComponent
    },
    {
        name: 'date-format',
        component: DateFormatSelectorComponent
    },
    {
        name: 'time-format',
        component: TimeFormatSelectorComponent
    },
    {
        name: 'timezone',
        component: TimezoneRegionsFormlyWrapperComponent
    },
    {
        name: 'file-name-input',
        component: FileNameInputComponent
    },
    {
        name: 'user-selector',
        component: UserSelectorComponent
    },
    {
        name: 'sftp-config',
        component: SftpConfigComponent
    },
    {
        name: 'time',
        component: TimeSelectorComponent
    },
    {
        name: 'formly-autocomplete',
        component: FormlyAutocompleteComponent
    },
    {
        name: 'form-array',
        component: FormlyFormArrayComponent
    },
    {
        name: 'form-group',
        component: FormlyFormGroupComponent
    }
];
